import { FC, useCallback, useState } from 'react';

interface MemoModalProps {
  open: boolean;
  isSaving: boolean;
  onSave: (memo: string) => void;
  onClose: () => void;
}

export const MemoModal: FC<MemoModalProps> = ({ open, isSaving, onSave, onClose }) => {
  const [memo, setMemo] = useState('');

  const handleSave = useCallback(() => {
    if (!memo.trim()) return;
    onSave(memo);
    setMemo('');
  }, [memo, onSave]);

  const handleClose = useCallback(() => {
    setMemo('');
    onClose();
  }, [onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-6"
      onClick={handleClose}
    >
      <div
        className="w-full max-w-sm rounded-2xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-center justify-between">
          <h3 className="text-base font-bold text-gray-800">메모 남기기</h3>
          <button
            onClick={handleClose}
            className="flex h-7 w-7 items-center justify-center rounded-full text-gray-400 hover:bg-gray-100"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
        <input
          type="text"
          value={memo}
          onChange={(e) => setMemo(e.target.value)}
          placeholder="예: 홍길동"
          maxLength={30}
          autoFocus
          className="mb-3 w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm placeholder:text-gray-300 focus:border-purple-400 focus:outline-none focus:ring-1 focus:ring-purple-400"
        />
        <button
          onClick={handleSave}
          disabled={isSaving || !memo.trim()}
          className={`w-full rounded-xl bg-purple-600 py-2.5 text-sm font-bold text-white active:bg-purple-700 ${
            isSaving || !memo.trim() ? 'opacity-50' : ''
          }`}
        >
          {isSaving ? '저장 중...' : '저장'}
        </button>
      </div>
    </div>
  );
};
